// import React, { useEffect, useState } from "react";
// import { useNavigate } from "react-router-dom";
// import "./LatestJobs.css";

// const Results = () => {
//   const [data, setData] = useState([]);
//   const navigate = useNavigate();

//   useEffect(() => {
//     const API_URL = process.env.REACT_APP_NODE_BACKEND_API_URL;
//     fetch(`${API_URL}/jobs`)
//       .then((res) => res.json())
//       .then((jobs) => {
//         const filtered = jobs.filter(
//           (job) => job.result && job.result.length > 0
//         );

//         const sorted = filtered.sort((a, b) => {
//           const aLatest = Math.max(
//             ...a.result.map((r) => new Date(r.updatedAt).getTime() || 0)
//           );
//           const bLatest = Math.max(
//             ...b.result.map((r) => new Date(r.updatedAt).getTime() || 0)
//           );
//           return bLatest - aLatest;
//         });

//         setData(sorted);
//       })
//       .catch((err) => console.error("Failed to fetch results:", err));
//   }, []);

//   return (
//     <div className="table-card">
//       <h3 className="table-title">Results</h3>
//       <table className="styled-table">
//         <thead>
//           <tr>
//             <th>Exam</th>
//           </tr>
//         </thead>
//         <tbody>
//           {data.slice(0, 15).map((item, idx) => (
//             <tr key={idx}>
//               <td style={{ display: "flex", alignItems: "center", gap: "8px" }}>
//                 <span style={{ color: "#000", fontSize: "20px", lineHeight: "1" }}>•</span>
//                 <a
//                   className="job-link"
//                   href="#"
//                   onClick={(e) => {
//                     e.preventDefault();
//                     navigate(`/job/${item._id}`);
//                   }}
//                   style={{
//                     textDecoration: "none",
//                     color: "#007bff",
//                   }}
//                 >
//                   {item.JobTitle}
//                 </a>
//               </td>
//             </tr>
//           ))}
//         </tbody>

//       </table>

//       {data.length > 15 && (
//         <div style={{ textAlign: "right", marginTop: "1rem" }}>
//           <button
//             className="see-all-btn"
//             onClick={() => navigate("/all-results")}
//           >
//             See All Results
//           </button>
//         </div>
//       )}
//     </div>
//   );
// };

// export default Results;





// import React, { useEffect, useState } from "react";
// import { useNavigate } from "react-router-dom";
// import "./LatestJobs.css";

// const Results = () => {
//   const [data, setData] = useState([]);
//   const navigate = useNavigate();

//   useEffect(() => {
//     const API_URL = process.env.REACT_APP_NODE_BACKEND_API_URL;
//     fetch(`${API_URL}/jobs`)
//       .then((res) => res.json())
//       .then((jobs) => {
//         const filtered = jobs.filter(
//           (job) => job.result && job.result.length > 0
//         );

//         const sorted = filtered.sort((a, b) => {
//           const aLatest = Math.max(
//             ...a.result.map((r) => new Date(r.updatedAt).getTime() || 0)
//           );
//           const bLatest = Math.max(
//             ...b.result.map((r) => new Date(r.updatedAt).getTime() || 0)
//           );
//           return bLatest - aLatest;
//         });

//         setData(sorted);
//       })
//       .catch((err) => console.error("Failed to fetch results:", err));
//   }, []);

//   return (
//     <div className="table-card">
//       <h3 className="table-title">Results</h3>
//       <table className="styled-table">
//         <thead>
//           <tr>
//             <th>Exam</th>
//           </tr>
//         </thead>
//         <tbody>
//           {data.slice(0, 15).map((item, idx) => (
//             <tr key={idx}>
//               <td style={{ display: "flex", alignItems: "center", gap: "8px" }}>
//                 <span style={{ color: "#000", fontSize: "20px", lineHeight: "1" }}>•</span>
//                 <a
//                   className="job-link"
//                   href="#"
//                   onClick={(e) => {
//                     e.preventDefault();
//                     navigate(`/job/${item.slug}`); // ✅ Use slug instead of _id
//                   }}
//                   style={{
//                     textDecoration: "none",
//                     color: "#007bff",
//                   }}
//                 >
//                   {item.JobTitle}
//                 </a>
//               </td>
//             </tr>
//           ))}
//         </tbody>
//       </table>

//       {data.length > 15 && (
//         <div style={{ textAlign: "right", marginTop: "1rem" }}>
//           <button
//             className="see-all-btn"
//             onClick={() => navigate("/all-results")}
//           >
//             See All Results
//           </button>
//         </div>
//       )}
//     </div>
//   );
// };

// export default Results;





import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import "./LatestJobs.css";

const Results = () => {
  const [data, setData] = useState([]);
  const navigate = useNavigate();

  useEffect(() => {
    const API_URL = process.env.REACT_APP_NODE_BACKEND_API_URL;
    fetch(`${API_URL}/jobs`)
      .then((res) => res.json())
      .then((jobs) => {
        const filtered = jobs.filter(
          (job) => job.result && job.result.length > 0
        );

        // 🔽 Sort based on latest updatedAt inside result array
        const sorted = filtered.sort((a, b) => {
          const aTime = Math.max(...a.result.map(r => new Date(r.updatedAt || 0).getTime()));
          const bTime = Math.max(...b.result.map(r => new Date(r.updatedAt || 0).getTime()));
          return bTime - aTime;
        });

        setData(sorted);
      })
      .catch((err) => console.error("Failed to fetch results:", err));
  }, []);

  return (
    <div className="table-card">
      <h3 className="table-title">Results</h3>
      <table className="styled-table">
        <thead>
          <tr>
            <th>Exam</th>
          </tr>
        </thead>
        <tbody>
          {data.slice(0, 15).map((item, idx) => (
            <tr key={idx}>
              <td style={{ display: "flex", alignItems: "center", gap: "8px" }}>
                <span style={{ color: "#000", fontSize: "20px", lineHeight: "1" }}>•</span>
                <a
                  className="job-link"
                  href="#"
                  onClick={(e) => {
                    e.preventDefault();
                    navigate(`/job/${item.slug}`);
                  }}
                  style={{
                    textDecoration: "none",
                    color: "#007bff",
                  }}
                >
                  {item.JobTitle}
                </a>
              </td>
            </tr>
          ))}
        </tbody>
      </table>

      {data.length > 15 && (
        <div style={{ textAlign: "right", marginTop: "1rem" }}>
          <button
            className="see-all-btn"
            onClick={() => navigate("/all-results")}
          >
            See All Results
          </button>
        </div>
      )}
    </div>
  );
};

export default Results;

